import type { MonitoringTab } from '@cobliteam/monitoring/src/hooks/useMonitoringTabs';
import { type ParseSpreadsheetFail, type ParseSpreadsheetStart, type ParseSpreadsheetSuccess, SpreadsheetActionTypes } from './actions';
import type { GenericSheet } from './parser/types';

export const parseSpreadsheetStart = (domain: MonitoringTab, file: File): ParseSpreadsheetStart => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_START,
  domain,
  payload: file,
});

export const parseSpreadsheetFail = (domain: MonitoringTab): ParseSpreadsheetFail => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_FAIL,
  domain,
});

export const parseSpreadsheetSuccess = <T = any>(domain: MonitoringTab, results: GenericSheet<T>): ParseSpreadsheetSuccess => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_SUCCESS,
  domain,
  payload: results,
});
